import '../src/assets/scss/index.scss';
import MainBody from '../src/components/MainBody';
import getParam from './utils/getParam';
import elemZoom from './utils/elemZoom';
import MainHeader from './components/MainHeader';
import { initSessionSync, checkAppVersion } from '../../html_iscreamtoolkit_new/src/components/sessionSyncWithAlert';

let game = { width: 540, height:570 };
let extraMargin = 28; //다른 서비스에 탑재시 상단 마진 28px 추가
let tm;
checkAppVersion(); //앱 버전 체크 시작(250402)
window.addEventListener("focus", () => {
    checkAppVersion(); // 포커스될 때도 확인
});
// new MainHeader();
new MainBody();


window.addEventListener('resize', (e) => {
    let vh = window.innerHeight * 0.01;
    if(getParam(window.parent.location.href, 'loc') == "other"){
        document.body.classList.add('is-other');
        elemZoom(game.width, game.height+extraMargin, true);
    }else{
        elemZoom(game.width, game.height, true);
    }
});

window.addEventListener('orientationchange', (e) => {
    if(getParam(window.parent.location.href, 'loc') == "other"){
        tm = setTimeout(() => {
            document.body.classList.add('is-other');
            elemZoom(game.width, game.height+extraMargin, true);
        }, 100);
        
    }else{
        tm = setTimeout(() => {
            elemZoom(game.width, game.height, true);
        }, 100);
    }
    
});

window.addEventListener('DOMContentLoaded', (e) => {
    if(getParam(window.parent.location.href, 'loc') == "other"){
        document.body.classList.add('is-other');
        elemZoom(game.width, game.height+extraMargin, true);
    }else{
        elemZoom(game.width, game.height, true);
    }
});

//수업도구 마우스다운시 상위 부모 툴레이어 zindex 변경하기
